import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';

import {Observable} from 'rxjs/Observable';
import {Project} from '../../core/models/project';
import {ProjectService} from '../../core/services/project.service';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';


@Injectable()
export class ProjectResolver implements Resolve<Observable<Project>> {

  constructor(private projectService: ProjectService) {
  }

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Project> {
    return this.projectService.getOne(route.paramMap.get('id'))
      .catch(error => {
        return Observable.of(null);
      });
  }
}
